import React from 'react'
import reactStamp from 'react-stamp'
import PatientInfo from './PatientInfo'
import PatientAvatar from './PatientPhoto'
import PrimaryCareCard from './PrimaryCareCard'
import HomeOfficeCard from './HomeOfficeCard'
import MediaQuery from 'react-responsive'
import './home.css'

export default reactStamp(React).compose({

    render() {

        let {practitioner, src, ...patientInfo} = this.props;

        return (

            <div className="main-panel-container">

                <MediaQuery maxWidth={920}>
                    <PatientAvatar src={src} single={true}/>
                    <PatientInfo single={true} {...patientInfo}/>
                    <PrimaryCareCard practitioner={practitioner}/>
                    <HomeOfficeCard single={true} practitioner={practitioner}/>
                </MediaQuery>

                <MediaQuery minWidth={920}>
                    <div className="double">
                        <PatientAvatar src={src}/>
                        <PatientInfo {...patientInfo}/>
                    </div>
                    <div className="double">
                        <PrimaryCareCard practitioner={practitioner}/>
                        <HomeOfficeCard practitioner={practitioner}/>
                    </div>
                </MediaQuery>

            </div>
        );
    },

});


/** WEBPACK FOOTER **
 ** ./src/app/components/Home/index.js
 **/